import { render, staticRenderFns } from "./Marcacion.vue?vue&type=template&id=d6ffdc1c&"
import script from "./Marcacion.vue?vue&type=script&lang=js&"
export * from "./Marcacion.vue?vue&type=script&lang=js&"
import style0 from "./Marcacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports